import template from './dropdown.html';
import { NotificationDropdownActions } from 'core/services/notifications';
import config from 'config.json';

export let DropdownComponent = {
  templateUrl: template,
  selector: 'notificationDropdown',
  bindings: {

  },
  controller: DropdownCtrl,
  controllerAs: 'vm'
};

DropdownCtrl.$inject = ['$ngRedux', '$scope', '$timeout', '$websocket'];

function DropdownCtrl($ngRedux, $scope, $timeout, $websocket) {
  this.mapStateToThis = mapStateToThis.bind(this);
  this.toggleDropdown = toggleDropdown.bind(this);
  this.setupListener = setupListener.bind(this);
  this.setupWebSocket = setupWebSocket.bind(this);
  this.handleMessage = handleMessage.bind(this);
  // mapea los tipos de notificaciones con su respectivo ícono.
  this.iconsMap = {
    'solicitud_permiso': 'bg-blue icon-envelope'
  };
  let unsubscribe;

  this.$onDestroy = () => {
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, NotificationDropdownActions)(this);
    this.initDropdown();
  };

  function mapStateToThis(state) {
    let user = state.currentUser.data;

    if (user.id && !this.initialized) {
      this.initialized = true;
      //this.setupWebSocket(user);
    }
    return {
      notificationDropdown: state.notificationDropdown,
      user
    };
  }

  function toggleDropdown() {
    if (this.notificationDropdown.opened) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }

    if (this.notificationDropdown.opened) {
      $timeout(() => this.setupListener());
    }

    if (this.notificationDropdown.closed) {
      $('html').off('click');
    }
  }


  function setupListener() {
    let vm = this;
    $('html').click((event) => {
      const isChild = $(event.target).parents('notification-dropdown').length > 0;

      if (!isChild) {
        $scope.$apply(() => vm.toggleDropdown());
      }
    });
  }

  function setupWebSocket(user) {
    const stream = $websocket(`${config.websocketURL}/notifications`);
    stream.onMessage(this.handleMessage);
    stream.send(JSON.stringify({ action: 'init', payload: user.username }));
  }


  /**
   * callback que se encarga de procesar el mensaje recibido vía websocket.
   * 
   * @param {Object} message - mensaje recibido
   */
  function handleMessage(message) {
    let parsedMessage = JSON.parse(message.data);

    if (parsedMessage.action === 'init') {
      this.notificationsLoaded(parsedMessage.payload);
    } else if (parsedMessage.action === 'new') {
      this.newNotification(parsedMessage.payload);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/notifications/dropdown/dropdown.component.js